export default {"src":"/_next/static/media/table-empty.5c70c818.svg","height":1585,"width":1787,"blurWidth":0,"blurHeight":0};